<template>
    <Input
        id="search"
        name="search"
        placeholder="Recherche"
        v-model="mutableSearch"
        @blur="handleBlurSearch"
        @input="handleInputSearch"
        class="mb-4"
        :debounceDelay=1000
    />
</template>

<script>
import Input from "../form/input";

export default {
    props: {
        search: String,
    },
    data() {
        return {
            delayer: null,
            mutableSearch: this.search,
        }
    },
    methods: {
        handleBlurSearch() {
            clearTimeout(this.delayer);
            this.$emit('change', this.mutableSearch);
        },
        handleInputSearch() {
            clearTimeout(this.delayer);
            this.delayer = setTimeout(() => this.$emit('change', this.mutableSearch), 1000);
        }
    },
    components: {
        Input
    }
}
</script>
